import { useState, useEffect, useMemo } from "react";
import Header from "../../components/Header/Header";
import Footer from "../../components/Footer/Footer";
import PrivacyPolicyContent from "../../components/PrivacyPolicyContent/PrivacyPolicyContent";
import { fetchPolicy } from "../../services/policyApi";
import { normalizePolicyDisplay } from "../../util/policyHelpers";
import "./Privacy.scss";
import Seo from "../../components/Seo/Seo";
import { PAGE_SEO } from "../../config/seoConfig";

function Privacy() {
  const [carousalStatus, setCarousalStatus] = useState(true);
  const [policyResponse, setPolicyResponse] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const loadPolicy = async () => {
      try {
        const policy = await fetchPolicy();
        setPolicyResponse(policy);
      } catch (error) {
        console.error("Failed to load policy", error);
        setPolicyResponse(null);
      } finally {
        setIsLoading(false);
      }
    };

    loadPolicy();
  }, []);

  const policyDisplay = useMemo(
    () => normalizePolicyDisplay(policyResponse),
    [policyResponse],
  );

  const handleClick = (data) => {
    setCarousalStatus(data);
  };

  if (isLoading) {
    return (
      <div className="loader-div">
        <div className="loader">
          <lottie-player
            autoplay
            loop
            src="https://lottie.host/7d0ba31f-e11f-47ed-8248-b1a8f5389ad8/oMZAHSKOuQ.json"
          ></lottie-player>
        </div>
      </div>
    );
  }

  return (
    <div className="main_container">
      <Seo {...PAGE_SEO.privacy} />
      <div className="privacy_page">
        <Header handleClick={handleClick} />
        <PrivacyPolicyContent policy={policyDisplay} />
      </div>
      <Footer />
    </div>
  );
}

export default Privacy;
